import CommentAPI from '@/app/apis/main/comments/comments-api.js';

export default {
	async getComments(options) {
		return CommentAPI.getComments(options);
	},

	/**
	 * @param {Number} commentId
	 * @return {Object} comment
	 * */
	async getCommentById(commentId) {
		return CommentAPI.getCommentById(commentId);
	},

	async deleteComment(commentId) {
		return CommentAPI.deleteComment(commentId);
	}
}